/**
 * @generated SignedSource<<0313dcba9a36c8efadd2a4abe63a6bef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useCanTriggerAIMessageSuggestionQuery$variables = {
  channelId: string;
};
export type useCanTriggerAIMessageSuggestionQuery$data = {
  readonly node: {
    readonly __typename: "ChatChannel";
    readonly id: string;
    readonly viewerPermissions: ReadonlyArray<string>;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type useCanTriggerAIMessageSuggestionQuery = {
  response: useCanTriggerAIMessageSuggestionQuery$data;
  variables: useCanTriggerAIMessageSuggestionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "channelId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "channelId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCanTriggerAIMessageSuggestionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "type": "ChatChannel",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCanTriggerAIMessageSuggestionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/)
            ],
            "type": "ChatChannel",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3c97e1f9a452ede4674e117d7a76b9a6",
    "id": null,
    "metadata": {},
    "name": "useCanTriggerAIMessageSuggestionQuery",
    "operationKind": "query",
    "text": "query useCanTriggerAIMessageSuggestionQuery(\n  $channelId: ID!\n) {\n  node(id: $channelId) {\n    __typename\n    ... on ChatChannel {\n      id\n      __typename\n      viewerPermissions\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "840fa21d675bef0a8b3b5d4907716107";

export default node;
